module.exports = __webpack_public_path__ + "static/media/21ECLAC4.b4f2f24f.jpg";